// Product gallery: one main image at a time with thumbnails and arrows.
// Thumbnails and arrows scroll the snap track; the active thumbnail follows the scroll position.
for (const root of document.querySelectorAll('[data-gallery]')) {
  const track = root.querySelector('[data-product-gallery]');
  const thumbs = [...(root.parentElement?.querySelectorAll('[data-gallery-thumb]') ?? [])];
  const prev = root.querySelector('[data-gallery-prev]');
  const next = root.querySelector('[data-gallery-next]');
  if (!track) continue;
  const slides = () => [...track.children];
  const current = () => {
    const width = track.clientWidth || 1;
    return Math.round(Math.abs(track.scrollLeft) / width);
  };
  const goTo = (index) => {
    const list = slides();
    index = Math.max(0, Math.min(index, list.length - 1));
    const target = list[index];
    if (!target) return;
    const dir = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
    track.scrollTo({ left: dir * index * track.clientWidth });
  };
  const update = () => {
    const index = current();
    thumbs.forEach((thumb, i) => {
      if (i === index) thumb.setAttribute('aria-current', 'true');
      else thumb.removeAttribute('aria-current');
    });
    if (prev) prev.disabled = index <= 0;
    if (next) next.disabled = index >= slides().length - 1;
    const active = thumbs[index];
    const strip = active?.parentElement;
    if (active && strip && strip.scrollWidth > strip.clientWidth) {
      strip.scrollTo({ left: active.offsetLeft - strip.clientWidth / 2 + active.clientWidth / 2, behavior: 'smooth' });
    }
  };
  thumbs.forEach((thumb) => thumb.addEventListener('click', () => goTo(Number(thumb.dataset.galleryThumb))));
  prev?.addEventListener('click', () => goTo(current() - 1));
  next?.addEventListener('click', () => goTo(current() + 1));
  let frame = 0;
  track.addEventListener('scroll', () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(update);
  }, { passive: true });
  update();
}
